<div class="col-md-12">
  <div class="row">
    <div class="col-md-12 text-right" style="margin-bottom: 10px;">
      <a (click)="abrirModalNovo()">
        <button class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button>
      </a>
    </div>
    <div class="col-md-12">
      <app-tabela
        titulo="Lista de configurações de email"
        placeHolder="Buscar configuração"
        [colunas]="colunas"
        [linhas]="linhas"
        [botaoEditar]="false"
        [botaoDeletar]= "true"
        [camposFiltro] = "false"
        (desativar)="desativarConfig($event)"
      ></app-tabela>
    </div>
  </div>
</div>

<div class="box-novo-compromisso" *ngIf="showModalNovo" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Nova Configuração de Email</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModalNovo()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="email">Email</label>
            <input type="email" class="form-control" [(ngModel)]="novaConfiguracaoEmail.email" id="email" name="email" placeholder="Digite o email">
          </div>
          <div class="form-group col-md-12">
            <label for="display">Display</label>
            <input type="text" class="form-control" [(ngModel)]="novaConfiguracaoEmail.display" id="display" name="display" placeholder="Digite o display">
          </div>
          <div class="form-group col-md-12">
            <label for="senha">Senha</label>
            <input type="password" class="form-control" [(ngModel)]="novaConfiguracaoEmail.senha" id="senha" name="senha" placeholder="Digite a senha">
          </div>
          <div class="form-group col-md-12">
            <label for="host">Host</label>
            <input type="text" class="form-control" id="host" [(ngModel)]="novaConfiguracaoEmail.host" name="host" placeholder="Digite o host ex:(imap.gmail.com)">
          </div>
          <div class="form-group col-md-12">
            <label for="porta">Porta</label>
            <input type="number" class="form-control" id="porta" [(ngModel)]="novaConfiguracaoEmail.porta" name="porta" placeholder="Digite a porta">
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-warning" (click)="fecharModalNovo()">Cancelar</button>
        </div>
        <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
          <button class="btn btn-primary" (click)="salvarConfiguracao()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</div>
